import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink , faAddressBook , faBuildingColumns , faEnvelope, faLocationDot , faPhone } from "@fortawesome/free-solid-svg-icons";
import { faInstagram , faFacebookF , faYoutube } from "@fortawesome/free-brands-svg-icons";
import './Footer.css';
import logo from '../assets/bca logo.webp';
import cbse from '../assets/cbse.webp';
import camb from '../assets/cambragelogo.webp';

const Footer = () => {
  const [currentPhrase, setCurrentPhrase] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  
  const phrases = [
    "creativity.",
    "global diversity.",
    "excellence.",
    "innovation."
  ];

  useEffect(() => {
    let charIndex = 0;
    const currentText = phrases[currentPhrase];
    
    setDisplayText('');
    setIsTyping(true);
    
    const typingInterval = setInterval(() => {
      if (charIndex < currentText.length) {
        setDisplayText(currentText.substring(0, charIndex + 1));
        charIndex++;
      } else {
        clearInterval(typingInterval);
        setIsTyping(false);
        
        setTimeout(() => {
          setCurrentPhrase((prev) => (prev + 1) % phrases.length);
        }, 1000);
      }
    }, 100);
    
    return () => clearInterval(typingInterval);
  }, [currentPhrase]);

  return (
    <footer>
      {/* Top Section */}
      <section className="bca-footer-top-wrapper">
        <div className="bca-footer-top-content">
          <div className="bca-footer-left fade-in-left">
            <h2 className="bca-footer-brand-title">CHOOSE THE BCA EXPERIENCE</h2>
            <p className="bca-footer-brand-text">
              Our rich history is the foundation for our values. Join us to make your school experience unforgettable.
            </p>
          </div>
          <div className="bca-footer-right">
            <div className="bca-footer-column" style={{animationDelay: '0.1s'}}>
              <h3 className="bca-column-title">
                <span className="bca-column-icon"><FontAwesomeIcon icon={faBuildingColumns} /></span>
                SISTER CONCERN
              </h3>
              <ul className="bca-column-links">
                <li><a href="https://www.bihanipharmacycollegesgnr.org/">›› SD Bihani Pharmacy College</a></li>
                <li><a href="https://www.sdbihanilawcollegesgnr.org/">›› SD Bihani Law College</a></li>
                <li><a href="https://sdbihanibedcollegesgnr.org/">›› SD Bihani B.Ed. College</a></li>
                <li><a href="https://sdbihanipgcollegesgnr.org/">›› SD Bihani PG College</a></li>
              </ul>
            </div>
            <div className="bca-footer-column" style={{animationDelay: '0.2s'}}>
              <h3 className="bca-column-title">
                <span className="bca-column-icon"><FontAwesomeIcon icon={faLink} /></span>
                QUICK LINKS
              </h3>
              <ul className="bca-column-links">
                <li><a href="#">›› Home</a></li>
                <li><a href="#">›› Activities</a></li>
                <li><a href="#">›› Fee Structure</a></li>
                <li><a href="#">›› Results</a></li>
                <li><a href="#">›› Contact</a></li>
              </ul>
            </div>
            <div className="bca-footer-column" style={{animationDelay: '0.3s'}}>
              <h3 className="bca-column-title">
                <span className="bca-column-icon"><FontAwesomeIcon icon={faAddressBook} /></span>
                CONTACT US
              </h3>
              <ul className="bca-column-links">
                <li><FontAwesomeIcon icon={faLocationDot} />Bihani Children Academy, Gaganpath, Jawahar Nagar, Sri Ganganagar, Rajasthan-335001</li>
                <li><FontAwesomeIcon icon={faPhone} />0154-2460807, 2461807</li>
                <li><FontAwesomeIcon icon={faEnvelope} />admin@bihanichildrensacademy.com</li>
              </ul>
            </div>
          </div>
          <div className="bca-footer-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4102.054285907766!2d73.87742697605196!3d29.917487424573935!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3917b51857c50fd3%3A0xe78093220632d25e!2sBihani%20Children%20Academy!5e1!3m2!1sen!2sin!4v1766038242837!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="BCA Location Map"
            ></iframe>
          </div>
        </div>
        <div className="bca-footer-cityscape"></div>
        <div className="footer-social">
          <a className="social-icon insta" href="https://www.instagram.com/bihani_childrens_academy?igsh=MWVpcHo0aWptc2pydA==" aria-label="Instagram">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a className="social-icon facebook" href="#" aria-label="Facebook">
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a className="social-icon youtube" href="https://www.youtube.com/channel/UCkgoZqhiORl0EWBTHf3_2Qw" aria-label="YouTube">
            <FontAwesomeIcon icon={faYoutube} />
          </a>
        </div>
      </section>

      {/* Bottom Section */}
      <section className="bca-footer-main-wrapper">
        <div className="bca-footer-center-content">
          <div className="bca-center-logo fade-in-center">
            <img src={logo} alt="BCA Logo" className="bca-footer-logo" />
          </div>
          <div className="bca-center-title fade-in-center-delay1">
            <h1>BIHANI CHILDREN'S</h1>
            <h2>ACADEMY</h2>
          </div>
          <div className="bca-center-boards fade-in-center-delay2">
            <img src={cbse} alt="CBSE" className="bca-board-logo" />
            <img src={camb} alt="Cambridge" className="bca-board-logo" />
          </div>
          <div className="bca-center-divider fade-in-center-delay3"></div>
        </div>
        <div className="bca-footer-bottom-bar fade-in-bottom">
          <p>© 2025 <strong>Bihani Children's Academy.</strong> All rights reserved. Designed and Developed by <strong>NISHANT & TARUN SARASWAT</strong></p>
        </div>
      </section>
    </footer>
  );
};

export default Footer;